module.exports = __webpack_public_path__ + "img/partner8.40f29db6.jpg";